import React, { Component, Fragment } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';

import API from '../../../utils/API';
import EventEmail from './email';
import NewEmailModal from './modals/addEmailModal';
import DeleteEmailModal from './modals/deleteDefaultModal';

import SectionHeader from '../../../components/views/SectionHeader';
import ActionButtonContainer from '../../../components/views/ActionButtonContainer';
import ViewsTable from '../../../components/tables/ViewsTable';
import EmailGrid from '../../../components/tables/EmailGrid';
import TemplateRenameModal from './modals/renameEmailTemplateModal';
import DuplicateEmailModal from './modals/duplicateEmailModal';
import TemplateCenterModal from '../../event/emails/modals/templateCenterModal';

let batchActionCB;
class EventEmails extends Component {
	constructor(props) {
		super(props);
		const customFieldColumns = {
			name: 'Name',
			subject: 'Subject',
			previewText: 'Preview Text'
		};
		const defaultFieldTypes = {
			name: 'text',
			subject: 'text',
			previewText: 'text'
		};

		const toggledColumns = {};
		const normalizedColumns = Object.keys(customFieldColumns).map((cfc) => {
			toggledColumns[cfc] = true;
			return {
				label: customFieldColumns[cfc],
				key: cfc,
				value: cfc,
				type: (defaultFieldTypes && defaultFieldTypes[cfc]) || typeof defaultFieldTypes[cfc],
				sortAsc: false,
				sortDesc: false
			};
		});


		delete toggledColumns[Object.keys(defaultFieldTypes)[0]];

		this.state = {
			orgId: this.props.orgId,
			sortedEmails: [],
			loading: false,
			selectedEmail: 0,
			emailSelected: false,
			addEmailModalOpen: false,
			newEmails: {},
			emailsViews: [],
			toggledColumns: toggledColumns,
			checkedEmails: {},
			sortByColumn: { name: true },
			loading: true,
			deletedEmails: [],
			deleteEmailsModalOpen: false,
			loading: false,
			keyedMetadata: [],
			columns: customFieldColumns,
			columnTypes: defaultFieldTypes,
			loading: true,
			selectedSection: 0,
			toggleRename: false,
			selectedRow: '',
			toggleDuplicateEmailModal: false,
			toggleTemplateCenter: false,
			platformTemplates: [],
			normalizedColumns: normalizedColumns,
			isGridLayout: false,
		};
	}

	componentDidMount() {
		const { orgId, programId } = this.props;
		API().get(`/Organizations/${orgId}/getPlatformEmailTemplates`).then((res) => {
			if (res.data) {
				this.setState({
					platformTemplates: res.data.platformTemplates,
					loading: false
				});
			}
		}
		);

	}

	toggleLayout = (selected) => {
		const { isGridLayout } = this.state;
		this.setState({ isGridLayout: selected });
	};

	deleteCheckedEmails = async (emails) => {
		const { eventId, orgId } = this.props;
		await API()
			.post(`Organizations/${orgId}/events/${eventId}/emails`, {
				emails: Object.keys(this.state.checkedEmails)
			})
			.then((res) => {
				if (res.data) {
					this.setState({
						addEmailModalOpen: false,
						deletedEmails: [...this.state.deletedEmails, ...Object.keys(this.state.checkedEmails)],
						sortedEmails: this.state.sortedEmails.filter(
							(e) => !Object.keys(this.state.checkedEmails).includes(e.id)
						),
						deleteEmailsModalOpen: false,
						checkedEmails: {}
					});
				}
			});

		this.setState({
			checkedEmails: {}
		});
	};

	deleteCheckedEmails = (emailIds) => {
		this.props.deleteEmails(emailIds, () => {
			this.toggleDeleteEmails();
			this.setState({ checkedEmails: {} });

		});
	};

	updateEmails = (updatedEmail) => {
		const tempEmails = this.state.sortedEmails;
		tempEmails[this.state.selectedEmail] = updatedEmail;
		this.setState({ sortedEmails: tempEmails });
	};

	toggleDeleteEmails = () => {

		this.setState({
			deleteEmailsModalOpen: !this.state.deleteEmailsModalOpen,
		});
	};

	toggleSingleDeleteEmailsModal = (emailId) => {
		const { toggleSingleDeleteEmails } = this.state;
		this.setState({ toggleSingleDeleteEmails: !toggleSingleDeleteEmails, selectedRow: emailId });
	};

	deleteSingleEmails = (emailId) => {
		this.props.deleteEmails([emailId], () => {
			this.setState({ toggleSingleDeleteEmails: false });
		});
	};

	toggleAddEmail = (cb) => {
		batchActionCB = cb;
		this.setState({ addEmailModalOpen: !this.state.addEmailModalOpen });
	};

	addEmail = (email, callback) => {

		this.props.addEmail(email, () => {
			callback && callback();
		});
		//this.toggleAddEmail();
	}
	toggleRenameModal = (emailId) => {
		const { toggleRename } = this.state;
		this.setState({ toggleRename: !toggleRename, selectedRow: emailId });
	};
	toggleDuplicateEmailModal = (emailId) => {
		const { toggleDuplicateEmailModal } = this.state;
		this.setState({ toggleDuplicateEmailModal: !toggleDuplicateEmailModal, selectedRow: emailId })
	}
	duplicateEmail = (emailId, name, callback) => {

		this.props.duplicateEmail(emailId, name, () => {
			batchActionCB && batchActionCB('update');
			callback();
		});
	}
	toggleTemplateCenter = () => {
		this.setState({ toggleTemplateCenter: !this.state.toggleTemplateCenter });
	};

	checkEntry = (entryId) => {
		const checked = this.state.checkedEmails;
		checked[entryId] ? delete checked[entryId] : (checked[entryId] = true);
		this.setState({
			checkedEmails: checked
		});
	};

	checkAllEntries = (entryIds) => {
		let checked = this.state.checkedEmails;
		entryIds.length > 0
			? entryIds.forEach((entryId) => {
				checked[entryId] = true;
			})
			: (checked = {});

		this.setState({
			checkedEmails: checked,
		});
	};

	uncheckEntries = () => {
		this.setState({
			checkedEmails: {}
		});
	};


	render() {
		const {
			selectedEmail,
			loading,
			deleteEmailsModalOpen,
			emailsViews,
			columnTypes,
			columns,
			selectedSection,
			checkedEmails,
			addEmailModalOpen,
			toggleRename,
			toggleSingleDeleteEmails,
			toggleDuplicateEmailModal,
			toggleTemplateCenter,
			platformTemplates,
			normalizedColumns,
			isGridLayout
		} = this.state;
		const { emails, program, orgId, programId } = this.props;

		const drafts = emails.filter((e) => e.status == 'Draft');
		const scheduled = emails.filter((e) => e.status == 'Scheduled');
		const sent = emails.filter((e) => e.status == 'Sent');
		const checkedCount = Object.keys(checkedEmails).length;
		//const campaignList = selectedSection == 0 ? drafts : selectedSection == 1 ? scheduled : sent;
		const campaignList = emails;
		let mainAction = [{ onClick: this.toggleTemplateCenter, label: 'Add Email Template ' }];
		let batchActions = [
			{
				label: 'Delete',
				iconClass: 'las la-trash-alt',
				class: 'danger',
				onClick: this.toggleDeleteEmails
			}
		];
		let searchEnabled = false;
		let checkedEntryCount = Object.keys(this.state.checkedEmails).length;
		let data = campaignList;
		let checkedRows = this.state.checkedEmails;
		let rowSettings = [
			{ label: <span><i className='las la-pen mr-10'></i>Rename Template</span>, onClick: this.toggleRenameModal },
			{ label: <span><i className='las la-copy mr-10'></i>Duplicate Template</span>, onClick: this.toggleDuplicateEmailModal },
			{ label: <span><i className='las la-trash mr-10'></i>Delete Template</span>, onClick: this.toggleSingleDeleteEmailsModal }
		];

		return (
			<Switch>
				<Route exact path={`/${orgId}/programs/${programId}/emails`}>
					<Fragment>
						<SectionHeader
							title={'Email Campaign Templates'}
							description="Email campaigns are used to send emails to attendees."
							enableLastLink={true}
							breadcrumbs={[
								{
									name: program.name
								}
							]}
						></SectionHeader>
						<div className="sectionContainer sectionBody">
							<ActionButtonContainer
								mainActions={mainAction}
								searchEnabled={searchEnabled}
								enabledViewSelection={true}
								isGridLayout={isGridLayout}
								toggleLayout={this.toggleLayout}
							/>

							{!isGridLayout ? (
								<div className='flex h-100 hasHeader'>
									<ViewsTable
										title={'Email'}
										columns={normalizedColumns}
										toggledColumns={this.state.toggledColumns}
										data={data}
										mainColumnActive={true}
										checked={checkedRows}
										checkRow={this.checkEntry}
										checkAllRows={this.checkAllEntries}
										rowSettings={rowSettings}
									/>
								</div>
							) : (
								<EmailGrid
									title={'Email'}
									data={data}
									orgId={orgId}
									eventId={programId}
									mainColumnActive={true}
									checked={checkedRows}
									checkRow={this.checkEntry}
									checkAllRows={this.checkAllEntries}
									account={this.props.account}
									isProgram={true}

								/>
							)}

						</div>
						<ActionButtonContainer
							batchActions={batchActions}
							checkedEntryCount={checkedEntryCount}
							entriesLength={data.length}
							uncheckEntries={this.uncheckEntries}
						/>


						{toggleTemplateCenter && (
							<TemplateCenterModal
								isOpen={toggleTemplateCenter}
								orgId={orgId}
								templates={this.state.templates}
								platformTemplates={platformTemplates}
								programId={programId}
								isProgram={true}
								event={this.props.program.eventDefaults}
								toggle={this.toggleTemplateCenter}
								update={this.updateCampaign}
								addCampaign={this.addCampaign}
								defaultSenderEmail={this.state.defaultSenderEmail}
								defaultSenderName={this.state.defaultSenderName}
								addProgramEmail={this.props.addEmail}
							/>
						)}
						{deleteEmailsModalOpen &&
							<DeleteEmailModal
								isOpen={deleteEmailsModalOpen}
								toggle={() => this.toggleDeleteEmails()}
								title={`Delete ${checkedCount > 1 ? 'Emails' : 'Email'}`}
								message={`You are about to delete ${checkedCount} ${checkedCount > 1
									? 'emails'
									: 'email'
									}, this is irreversible,
	would you like to continue?`}
								submit={() =>
									this.deleteCheckedEmails(Object.keys(checkedEmails))}
							/>
						}

						{toggleSingleDeleteEmails &&
							<DeleteEmailModal
								isOpen={toggleSingleDeleteEmails}
								toggle={() => this.toggleSingleDeleteEmailsModal()}
								title={`Delete Email`}
								message={`You are about to delete this email.This action is irreversible.Would you like to continue?`}
								submit={() =>
									this.deleteSingleEmails(this.state.selectedRow, () => {
										this.setState({ toggleSingleDeleteEmails: false });
									})}
							/>
						}
						{
							toggleRename && (
								<TemplateRenameModal
									isOpen={toggleRename}
									emailTemplate={campaignList.find((e) => e._id == this.state.selectedRow)}
									orgId={orgId}
									toggle={this.toggleRenameModal}
									update={(content) => {
										this.props.saveEmail(content, () => {
											this.toggleRenameModal();
										});
									}}
								/>
							)
						}
						{
							toggleDuplicateEmailModal && <DuplicateEmailModal
								toggle={this.toggleDuplicateEmailModal}
								isOpen={toggleDuplicateEmailModal}
								name={campaignList.find((e) => e._id == this.state.selectedRow).name}
								emailId={campaignList.find((e) => e._id == this.state.selectedRow)._id}
								orgId={orgId}
								programId={program._id}
								duplicateEmail={this.duplicateEmail}
							/>
						}
					</Fragment>
				</Route>

				<Route path={`/${orgId}/programs/${programId}/emails/:emailId`}>
					<EventEmail
						program={program}
						programId={programId}
						orgId={orgId}
						index={selectedEmail}
						emails={emails}
						saveEmail={this.props.saveEmail}
						updateEmails={this.updateEmails}
						keyedMetadata={this.state.keyedMetadata}
						attendeeFields={this.props.attendeeFields}
						eventFields={this.props.eventFields}
						deleteSingleEmails={this.deleteSingleEmails}
						duplicateEmail={this.duplicateEmail}
					/>
				</Route>
			</Switch>
		);
	}
}

export default withRouter(EventEmails);
